<template>
    <div class="EstimationsDataEntry">
        <!-- Sales/Profit -->
        <Mikomi_SP :MikomiTypeData="SalesProfitData" :CellTitlePrefix="CellTitlePrefix + ''" :CellColor="CellColor" />
        <!-- Others -->
        <Mikomi_Game :MikomiTypeData="OtherData" :CellTitlePrefix="CellTitlePrefix + ''" :CellColor="CellColor" />
    </div>
</template>

<script>
import Mikomi_SP from './Mikomi_SP.vue';
import Mikomi_Game from './Mikomi_Game.vue';
export default{
    components:{
        Mikomi_SP,
        Mikomi_Game,
    },
    computed:{
        SalesProfitData()
        {
            return {
                sales: this.MikomiTypeData?.sales,
                provProfit: this.MikomiTypeData?.provGrossOperatingProfit !== undefined ? this.MikomiTypeData.provGrossOperatingProfit : this.MikomiTypeData?.provProfit,
            };
        },
        OtherData()
        {
            return {
                sales: this.MikomiTypeData?.sales,
                operatingProfit: this.MikomiTypeData?.operatingProfit,
                netIncome: this.MikomiTypeData?.netIncome,
                stock: this.MikomiTypeData?.stock
            };
        },
    },
    props:{
        MikomiTypeData: Object,
        CellTitlePrefix: String,
        CellColor: String,
        Team: String,
    },
    // mounted(){
    //     if (this.CellTitlePrefix === '差額 ')
    //      console.log(`[Mikomi_Type_Game] ${this.Team}`, this.MikomiTypeData);
    // }
}
</script>